import { useEffect } from "react";

export type SeoMetaProps = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  type?: "website" | "article";
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

const DEFAULT_IMAGE =
  "https://readdy.ai/api/search-image?query=abstract%20dramatic%20stage%20spotlight%20beams%20through%20smoky%20dark%20theater%20with%20deep%20vermillion%20and%20warm%20gold%20lighting%2C%20cinematic%20entertainment%20mood%2C%20no%20people&width=1200&height=630&seq=dujia-og-default&orientation=landscape";

function buildCanonical(path: string) {
  const base = __BASE_PATH__.replace(/\/$/, "");
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (typeof window === "undefined") {
    return `${base}${normalized}`;
  }
  return `${window.location.origin}${base}${normalized}`;
}

export default function SeoMeta({
  title,
  description,
  keywords,
  path,
  type = "website",
  image,
  jsonLd,
}: SeoMetaProps) {
  const canonical = buildCanonical(path);
  const ogImage = image ?? DEFAULT_IMAGE;
  const jsonLdText = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    const id = "page-structured-data";
    const existing = document.getElementById(id);
    if (existing) {
      existing.remove();
    }
    if (!jsonLdText) {
      return undefined;
    }
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = jsonLdText;
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, [jsonLdText]);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="独家大瓜" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
}